<template>
  <main-layout
    class="insurance"
    :page-title="title"
    @listen-back="goBack"
    customBack
    v-if="isshow"
  >
    <!-- v-loading="loading" -->
    <div slot="main-content" class="main-content">
      <div class="ruralContent">
        <div
          v-for="item in insuranceList"
          :key="item.id"
          @click="goToDetail(item)"
          :class="[
            { firstImg: item.id == 1 },
            { secondImg: item.id == 2 },
            { thirdImg: item.id == 3 },
          ]"
        >
          <div class="ruralBlock">
            <img src="@/assets/images/ruralInsurance/bao.png" alt="" />
            <span class="insuranceText">{{ item.insureName }}</span>
          </div>
        </div>

        <!-- <div
          class="secondImg"
          @click="goToDetail('insurance2')"
          v-if="insuranceTowName"
        >
          <div class="ruralBlock">
            <img src="@/assets/images/ruralInsurance/bao.png" alt="" />
            <span class="insuranceText">{{ insuranceTowName }}</span>
          </div>
        </div>

        <div
          class="thirdImg"
          v-if="insuranceThreeName && cityId == '310113'"
          @click="goToDetail('insurance3')"
        >
          <div class="ruralBlock">
            <img src="@/assets/images/ruralInsurance/bao.png" alt="" />
            <span class="insuranceText">{{ insuranceThreeName }}</span>
          </div>
        </div> -->
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { getStorage, SessionStorage } from "@/utils/storage";
import {
  getOrderlist,
  ruralInsurance,
  getInsureInfo,
} from "@/api/request/snkd.produce";
import { windowHref } from "@/utils/index";
import { mapState, mapActions } from "vuex";
export default {
  name: "InsuranceList",
  components: { MainLayout },
  data() {
    return {
      // 险种名称
      title: "农业保险",
      // 判断来的页面
      pathWhere: getStorage("pathWhere") ? getStorage("pathWhere") : "",
      // 是否有订单列表
      listHave: [],
      insureOrderLength: null,
      insuranceOneName: "",
      insuranceTowName: "",
      insuranceThreeName: "",
      cityId: "310000",
      ruralInsuranceLength: null, //若已投保穗优险
      // 是否显示页面
      isshow: false,
      insuranceId: "",
      insuranceName: "",
      insureBSOrderLength: null,
      insuranceList: [],
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },

  async created() {
    this.cityId = JSON.parse(localStorage.getItem("FARMINFO")).countyId;
    await this.getListInsure();
    await this.getInLists();
    await this.getInListsArea();
    await this.getRuralLists();
  },
  mounted() {},
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    // 获取保险品种列表-保险名字
    async getListInsure() {
      const res = await getInsureInfo({
        enableFlag: 1,
        pageNo: 1,
        pageSize: 20,
      });
      if (res.respCode === 0) {
        const list = res.obj.list;

        if (this.cityId !== "310113") {
          let i = list.findIndex((item) => item.id === 3);
          list.splice(i, 1);
          this.insuranceList = list;
        } else {
          this.insuranceList = list;
        }
        // this.insuranceOneName = list[0] ? list[0].insureName : "";
        // this.insuranceTowName = list[1] ? list[1].insureName : "";
        // this.insuranceThreeName = list[2] ? list[2].insureName : "";
      }
    },

    // 获取蔬菜订单列表 --->
    async getInLists() {
      const { respCode, obj } = await getOrderlist({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 20,
        insureId: 1,
      });
      if (respCode === 0) {
        this.listHave = obj.list;
        this.insureOrderLength = obj.list.length;
        this.isshow = true;
      }
    },
    //宝山 获取蔬菜订单列表 --->
    async getInListsArea() {
      const { respCode, obj } = await getOrderlist({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 20,
        insureId: 3,
      });
      if (respCode === 0) {
        this.listHave = obj.list;
        this.insureBSOrderLength = obj.list.length;
        this.isshow = true;
      }
    },

    //获取穗优意向单列表
    async getRuralLists() {
      const { respCode, obj } = await ruralInsurance.getInsureOrderListSummary({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 20,
        insureId: 2,
        orderStatus: "",
        grainType: "",
      });
      if (respCode === 0) {
        this.ruralInsuranceLength = obj.list.length;
        this.isshow = true;
      }
    },
    //跳转
    async goToDetail(text) {
      if (text.id === 1) {
        this.insuranceId = text.id;
        // hasPermission()
        const res = await this.hasPermission("produce:vegetableInsure");
        //权限判断运营平台企业是否勾选
        if (res) {
          SessionStorage.set("insureInfo", {
            id: this.insuranceId,
            name: text.insureName,
          });
          //是否已有保险列表
          if (this.insureOrderLength) {
            // this.$router.push("/insurance");
            this.$router.push({
              name: "Insurance",
            });
          } else {
            //没有就跳转保险介绍页
            // this.$router.push("/introducedJs");
            this.$router.push({
              name: "IntroducedJs",
            });
          }
        } else {
          this.$message({
            message: "您的权限无法使用该功能，可联系超级管理员修改权限",
            type: "warning",
          });
        }
      } else if (text.id === 2) {
        const res = await this.hasPermission("produce:ruralinsurance");
        this.insuranceId = text.id;
        SessionStorage.set("insureInfo", {
          id: this.insuranceId,
          name: text.insureName,
        });
        if (res) {
          // this.ruralInsuranceLength = 0;
          if (this.ruralInsuranceLength) {
            this.$router.push("/ruralList");
          } else {
            this.$router.push("/introduce");
          }
        } else {
          this.$message({
            message: "您的权限无法使用该功能，可联系超级管理员修改权限",
            type: "warning",
          });
        }
      } else if (text.id === 3) {
        this.insuranceId = 3;
        SessionStorage.set("insureInfo", {
          id: this.insuranceId,
          name: text.insureName,
        });
        if (this.insureBSOrderLength) {
          // this.$router.push("/insurance");
          this.$router.push({
            name: "Insurance",
          });
        } else {
          this.$router.push({
            name: "IntroducedJs",
          });
        }
      }
    },
    // 返回上一级跳转到列表页  判断返回页面
    goBack() {
      // 回到主页
      windowHref("/home/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;
    .ruralContent {
      justify-content: flex-start;
      display: flex;
      flex-wrap: wrap;
      div {
        width: 202px;
        height: 210px;
        border-radius: 15px;
        color: #ffffff;
      }

      .ruralBlock {
        background: rgba(0, 0, 0, 0.5);
        box-shadow: 0px 3px 10px rgba(85, 84, 127, 0.12);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          width: 36px;
          height: 46px;
          z-index: 10;
        }
      }
      .firstImg {
        margin-left: 30px;
        margin-top: 30px;
        background: url("~@/assets/images/ruralInsurance/firstInsurance.png");
        background-size: cover;
      }
      .secondImg {
        margin-left: 30px;
        margin-top: 30px;
        background: url("~@/assets/images/ruralInsurance/secondInsurance.png");
        background-size: cover;
      }
      .thirdImg {
        margin-left: 30px;
        margin-top: 30px;
        background: url("~@/assets/images/ruralInsurance/thirdInsurance.png");
        background-size: cover;
      }
    }
  }
}
.insuranceText {
  display: inline-block;
  margin: 0px 15px;
  font-family: "OPPOSans";
  font-style: normal;
  margin-top: 7px;
  font-size: 16px;
  font-weight: 400;
  text-align: center;

  line-height: 24px;
}
::v-deep .common-page-header .title {
  font-size: 22px !important;
}
</style>
